export const PAYMENT_METHODS = {
  CREDIT_CARD: "Cartão de crédito",
  TWO_CREDIT_CARDS: "2 cartões de crédito",
  BOLETO: "Boleto",
  PIX: "Pix",
  PAYPAL: "PayPal",
  TICKET: "Ticket",
  EFECTY: "Efecty",
  OXXO: "OXXO",
  DEBITCARD: "Cartão de Débito",
  EFT: "Transferência Eletrônica",
  SPEI: "SPEI",
  SENCILLITO: "Sencillito",
  FREE: "Gratuito",
  "SAFETYPAY-CASH": "SafetyPay Cash",
  GOOGLE_PAY: "Google Pay",
  APPLE_PAY: "Apple Pay",
  NEQUI: "Nequi",
  YAPE: "Yape",
  MERCADOPAGO: "Mercado Pago",
  PSE: "PSE",
  BALOTO: "Baloto",
  BANCOLOMBIA: "Bancolombia",
  PAGOEFECTIVO: "Pago Efectivo",
  MACHPAY: "Mach Pay",
  SERVIPAG: "Servipag",
  PAYNET: "Paynet",
  BANKTRANSFER: "Bank Transfer",
};

export function getPaymentMethod(method) {
  if (!method) return "";

  return PAYMENT_METHODS[method] || method;
}

export function getPaymentMethodList() {
  return Object.entries(PAYMENT_METHODS).map(([id, name]) => ({ id, name }));
}